module.exports = __webpack_public_path__ + "static/media/uber-logo-png-1581.e5edf687.png";